import { BaseSyntheticEvent } from 'react';
import Logger from '../Logger/Logger';

const logger = Logger.Create('Utils');

/**
 * Utility service.
 */
export default class Utils
{
  /**
   * Disables the context menu when the user taps and hold on the screen.
   * @param event The touch event.
   */
  public static disableContextMenu(event: MouseEvent): void
  {
    // Ensures that any touch events does not go past
    // this rendered component.
    event.preventDefault();
  }

  /**
   * Downloads a given file.
   */
  public static downloadFile(filename: string): void
  {
    const url = `${window.location.origin}/Exports/${filename}`;
    logger.info(`Attempting to download the file: ${url}}`);

    var tempLink = document.createElement('a');
    tempLink.href = url;
    tempLink.setAttribute('download', url);
    tempLink.click();
  }

  /**
   * Check if all values in array is equal.
   * @param array The array to check.
   */
  public static areAllEqual<T>(array: T[])
  {
    return new Set(array).size == 1;
  }
}
